/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { RootState, useTivoSelector } from '../../core/tivo/tivo-redux-wrapper';

const URLChangeEvents: FunctionComponent = (): JSX.Element => {
    const urlChangeEvents = useTivoSelector((state: RootState) => state.urlChangeEvents);
    const { url } = urlChangeEvents;
    return <Navigate to={{ pathname: url }} />;
};

export default URLChangeEvents;
